
<template>
    <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet">
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css">
    <div class="confirmation">
      <main>
        <div class="auth-wrapper d-flex align-items-center py-5">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-xl-8 col-lg-10">
                <div class="auth-card p-4">
                  <!-- Header -->
                  <div class="text-center mb-4">
                    <img src="../assets/neolink.png" alt="Logo" class="mb-3" style="width: 48px;">
                    <h1 class="fs-2 fw-bold">{{ t('confirmation.title') }}</h1>
                    <p class="text-muted">{{ t('confirmation.subtitle') }}</p>
                  </div>
                  
                  <!-- Alert notifications -->
                  <div class="alert alert-danger" v-if="error" role="alert">
                    {{ error }}
                  </div>
                  <div class="alert alert-success" v-if="success" role="alert">
                    {{ success }}
                  </div>
                  
                  <form @submit.prevent="handleSubmit">
                    <!-- Password fields -->
                    <div class="bg-light p-4 rounded mb-3">
                      <div class="mb-3 position-relative">
                        <div class="input-group">
                          <input
                            v-model="formData.password"
                            :type="showPassword ? 'text' : 'password'"
                            class="form-control"
                            :placeholder="t('confirmation.placeholder.password')"
                            required
                          >
                          <button 
                            class="btn btn-outline-secondary" 
                            type="button"
                            @click="showPassword = !showPassword"
                          >
                            <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                          </button>
                        </div>
                      </div>
                      <div class="mb-3 position-relative">
                        <div class="input-group">
                          <input
                            v-model="formData.confirmPassword"
                            :type="showConfirmPassword ? 'text' : 'password'"
                            class="form-control"
                            :placeholder="t('confirmation.placeholder.confirmPassword')"
                            required
                          >
                          <button 
                            class="btn btn-outline-secondary" 
                            type="button"
                            @click="showConfirmPassword = !showConfirmPassword"
                          >
                            <i :class="showConfirmPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                          </button>
                        </div>
                      </div>
                    </div>
  
                    <!-- Password requirements -->
                    <div class="alert alert-info mb-4">
                      <i class="fas fa-info-circle me-2"></i>
                      {{ t('confirmation.passwordRequirements') }}
                    </div>
  
                    <!-- Buttons -->
                    <div class="d-grid gap-2 mb-4">
                      <!-- Submit button full width -->
                      <button
                        type="submit"
                        class="btn btn-primary w-100"
                        :disabled="isLoading"
                      >
                        {{ isLoading ? t('confirmation.loading') : t('confirmation.activate') }}
                      </button>
                    </div>
  
                    <!-- Back link -->
                    <div class="text-center mb-4">
                      {{ t('confirmation.backText') }} <router-link to="/connexion" class="text-decoration-none">{{ t('confirmation.loginLink') }}</router-link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <TheFooter />
    </div>
</template>
  

<script>
// AJOUTER ces imports :
import TheFooter from "@/components/layout/Footer.vue";
import { dashboardService } from '@/services/api';
import { useTranslation } from '@/composables/useTranslation';

export default {
  name: "ConfirmationView",
  components: {
    TheFooter,
  },
  // AJOUTER cette fonction :
  setup() {
    const { t } = useTranslation()
    return { t }
  },
  // TON CODE EXISTANT RESTE IDENTIQUE :
  data() {
    return {
      formData: {
        password: '',
        confirmPassword: '',
        token: ''
      },
      isLoading: false,
      error: '',
      success: '',
      showPassword: false,
      showConfirmPassword: false
    }
  },

  created() {
    this.formData.token = this.$route.params.token;
    
    if (!this.formData.token) {
      // CHANGER ce message pour utiliser les traductions :
      this.error = this.t('confirmation.invalidToken');
    }
  },

  methods: {
    async handleSubmit() {
      if (this.formData.password !== this.formData.confirmPassword) {
        // CHANGER ce message pour utiliser les traductions :
        this.error = this.t('confirmation.passwordMismatch');
        return;
      }

      if (this.formData.password.length < 8) {
        // CHANGER ce message pour utiliser les traductions :
        this.error = this.t('confirmation.passwordTooShort');
        return;
      }

      const hasUpperCase = /[A-Z]/.test(this.formData.password);
      const hasLowerCase = /[a-z]/.test(this.formData.password);
      const hasNumbers = /\d/.test(this.formData.password);

      if (!hasUpperCase || !hasLowerCase || !hasNumbers) {
        // CHANGER ce message pour utiliser les traductions :
        this.error = this.t('confirmation.passwordRequirementsError');
        return;
      }

      this.isLoading = true;
      this.error = '';
      this.success = '';

      try {
        await dashboardService.confirmRegistration(
          this.formData.token,
          this.formData.password
        );

        // CHANGER ce message pour utiliser les traductions :
        this.success = this.t('confirmation.success');
        
        setTimeout(() => {
          this.$router.push('/connexion');
        }, 3000);

      } catch (error) {
        // CHANGER ce message pour utiliser les traductions :
        this.error = error.response?.data?.message || this.t('confirmation.error');
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>


  <style lang="scss" scoped>
  @import '@/assets/styles/main.scss';
  
  :root {
    --bs-primary: #000000;
  }
  
  .auth-wrapper {
    min-height: 100vh;
    background-color: #f8f9fa;
  }
  
  .auth-card {
    background: white;
    border-radius: 1rem;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  }
  </style>